import React from "react";
import { createRoot } from "react-dom/client";
import { Quiz } from "./Quiz";
import { clearQuizSession } from "../../hooks/useSessionStorage";
import { QuizMeta } from "./types";

/**
 * Mount the React Quiz app into #quiz. Call when .template-quiz exists.
 */
export function mountQuiz(clearSession: boolean = false): void {
  const el = document.getElementById("quiz");

  if (!el) {
    console.warn("No quiz container found!");
    return;
  }

  const params = new URLSearchParams(window.location.search);

  if (params.has("clear") || clearSession) {
    clearQuizSession();
  }

  const windowBrave = window as Window & { Brave?: { QuizMeta?: QuizMeta } };

  const entrypoints = windowBrave.Brave?.QuizMeta?.entrypoints;
  const questions = windowBrave.Brave?.QuizMeta?.questions;
  const answers = windowBrave.Brave?.QuizMeta?.answers;
  const endStates = windowBrave.Brave?.QuizMeta?.endStates;

  const root = createRoot(el);
  root.render(
    <React.StrictMode>
      <Quiz
        entrypoints={entrypoints ?? []}
        questions={questions ?? []}
        answers={answers ?? []}
        endStates={endStates ?? []}
      />
    </React.StrictMode>
  );
}
